import { TweenMax } from 'gsap';

class Cursor {
  constructor() {
    this.cursorContainer = document.querySelectorAll('.js--cursor');
    this.cursorType = '';
    this.cursor = '';
    this.isMoving = false;
    this.initialize();
  }

  initialize() {
    const cursors = Array.from(this.cursorContainer);
    if (cursors.length) {
      cursors.forEach(cursor => {
        cursor.addEventListener('mousemove', this.mouseMove.bind(this));
        cursor.addEventListener('mouseleave', this.mouseLeave.bind(this));
      });
    }
  }

  mouseMove(e) {
    const x = e.clientX;
    const y = e.clientY;
    this.cursorType = e.currentTarget.getAttribute('data-cursor');
    this.cursor = document.querySelector(`.cursor--${this.cursorType}`);
    const cursorWidth = this.cursor.offsetWidth;

    if (!this.isMoving) {
      this.isMoving = true;
      TweenMax.set(this.cursor, {
        opacity: 1,
      });
    }

    TweenMax.set(this.cursor, {
      x: x - cursorWidth / 2,
      y: y - cursorWidth / 2,
    });
  }

  mouseLeave() {
    this.isMoving = false;
    TweenMax.set(this.cursor, {
      opacity: 0,
    });
  }
}

export default Cursor;
